export const AUTH_CONFIG = {
  SESSION_CACHE_DURATION_MS: 5000,
  TOKEN_NEAR_EXPIRY_THRESHOLD_MS: 60000,
} as const;

export const AUTH_ROUTES = {
  LOGIN: '/login',
  OTP: '/otp',
  HOME: '/',
} as const;

export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
} as const;

export const AUTH_FLOW_TYPES = {
  CUSTOM_WITHOUT_SRP: 'CUSTOM_WITHOUT_SRP',
} as const;

export const SIGN_IN_STEPS = {
  CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE:
    'CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE',
  DONE: 'DONE',
} as const;

export const COGNITO_ERRORS = {
  USERNAME_EXISTS: 'UsernameExistsException',
  NOT_AUTHORIZED: 'NotAuthorizedException',
  USER_NOT_FOUND: 'UserNotFoundException',
  CODE_MISMATCH: 'CodeMismatchException',
  EXPIRED_CODE: 'ExpiredCodeException',
  LIMIT_EXCEEDED: 'LimitExceededException',
  TOO_MANY_REQUESTS: 'TooManyRequestsException',
} as const;

export const AUTH_MESSAGES = {
  SESSION_EXPIRED: 'Your session has expired. Please log in again.',
  SESSION_EXPIRING_SOON: 'Your session will expire in 2 minutes.',
  INVALID_OTP: 'Invalid verification code. Please try again.',
  OTP_EXPIRED: 'Verification code has expired. Please request a new one.',
  OTP_SENT: 'Verification code sent to your email.',
  NETWORK_ERROR: 'Network error. Please check your connection and try again.',
  RATE_LIMITED: 'Too many attempts. Please wait a moment and try again.',
  GENERIC_ERROR: 'An error occurred. Please try again.',
  LOGOUT_SUCCESS: 'You have been logged out successfully.',
} as const;

export const DEV_SANDBOX_DOMAIN = 'dev-sbx.synopsis.rozie.ai';

export const TOAST_DURATION = {
  SHORT: 3000,
  MEDIUM: 5000,
  LONG: 8000,
} as const;
